import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-finance-explore',
    standalone: true,
    imports: [CommonModule, TranslateModule, MatIconModule],
    templateUrl: './finance-explore.component.html',
})
export class FinanceExploreComponent {
    @Input() caseId: any;
    @Input() isDisabled: boolean = false;
    @Input() isSelected: boolean = false;
}
